<template>
  <MonacoEditor
    ref="editor"
    v-model="mCode"
    class="Code"
    :options="options"
    :language="language.name"
    theme="vs-dark"
    @editorDidMount="editorDidMount"
  />
</template>
<script>
import { mapGetters } from 'vuex';
import MonacoEditor from 'vue-monaco';
// import monokai from '../../assets/editor-theme.json'
// import monokai from 'monaco-themes/themes/Vibrant Ink.json';

export default {
  name: 'Code',
  components: {
    MonacoEditor,
  },
  props: {
    code: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    monaco: undefined,
    editor: null,
    options: {
      automaticLayout: true,
      theme: 'vs-dark',
      scrollbar: {
        useShadows: false,
        verticalHasArrows: true,
        horizontalHasArrows: true,
        vertical: 'hidden',
        horizontal: 'visible',
        verticalScrollbarSize: 2,
        horizontalScrollbarSize: 3,
        arrowSize: 30,
      },
      minimap: {
        enabled: false,
      },
    },
  }),
  watch: {
    language: function() {
      this.monaco.setModel(this.monaco.getModel(), this.language.name);
    },
  },
  computed: {
    ...mapGetters({
      language: 'activeLanguage',
      snippet: 'activeSnippet',
    }),

    mCode: {
      get() {
        return this.code || '';
      },
      set(val) {
        this.$emit('update', val);
      },
    },
  },
  methods: {
    editorDidMount() {
      this.monaco = this.$refs.editor.getEditor();
    },
  },
};
</script>
<style lang="scss">
.Code {
  margin-top: 30px;
  flex: 1;
  font-weight: 700;

  .monaco-editor,
  .monaco-editor-background,
  .monaco-editor .inputarea.ime-input {
    background: transparent;
  }

  .monaco-editor {
    background: transparent;
    margin-left: -61px;

    .margin {
      background: transparent;
    }
  }
  /* Common overrides */
  .monaco-editor .line-numbers {
    color: currentColor;
    opacity: 0.5;
  }

  /* Light theme overrides */
  .ayu-light .JsxText {
    color: #5c6773;
  }

  .ayu-light .JsxSelfClosingElement,
  .ayu-light .JsxOpeningElement,
  .ayu-light .JsxClosingElement,
  .ayu-light .tagName-of-JsxOpeningElement,
  .ayu-light .tagName-of-JsxClosingElement,
  .ayu-light .tagName-of-JsxSelfClosingElement {
    color: #41a6d9;
  }

  .ayu-light .name-of-JsxAttribute {
    color: #f08c36;
  }

  .ayu-light .name-of-PropertyAssignment {
    color: #86b300;
  }

  .ayu-light .name-of-PropertyAccessExpression {
    color: #f08c36;
  }

  /* Dark theme overrides */
  .ayu-dark .JsxText {
    color: #d9d7ce;
  }

  .ayu-dark .JsxSelfClosingElement,
  .ayu-dark .JsxOpeningElement,
  .ayu-dark .JsxClosingElement,
  .ayu-dark .tagName-of-JsxOpeningElement,
  .ayu-dark .tagName-of-JsxClosingElement,
  .ayu-dark .tagName-of-JsxSelfClosingElement {
    color: #5ccfe6;
  }

  .ayu-dark .name-of-JsxAttribute {
    color: #ffcf71;
  }

  .ayu-dark .name-of-PropertyAssignment {
    color: #bae67e;
  }

  .ayu-dark .name-of-PropertyAccessExpression {
    color: #ffcf71;
  }
}
</style>
